import React from 'react';
import { cn } from '@/lib/utils';

const statusConfig = {
  new: { label: 'Nouveau', className: 'bg-slate-100 text-slate-700 border-slate-200' },
  imported: { label: 'Importé', className: 'bg-blue-50 text-blue-700 border-blue-100' },
  summarized: { label: 'Analysé', className: 'bg-indigo-50 text-indigo-700 border-indigo-100' },
  draft_ready: { label: 'Brouillon prêt', className: 'bg-emerald-50 text-emerald-700 border-emerald-100' },
  needs_human_review: { label: 'Revue requise', className: 'bg-amber-50 text-amber-800 border-amber-200' },
  approved: { label: 'Approuvé', className: 'bg-green-50 text-green-700 border-green-100' },
  published: { label: 'Publié', className: 'bg-green-100 text-green-800 border-green-200' },
  manual_publish_required: { label: 'À publier', className: 'bg-orange-50 text-orange-700 border-orange-200' },
  rejected: { label: 'Rejeté', className: 'bg-red-50 text-red-700 border-red-100' },
  waiting_cleaning_report: { label: 'En attente ménage', className: 'bg-amber-50 text-amber-700 border-amber-200' },
};

export const StatusBadge = ({ status, className }) => {
  const config = statusConfig[status] || { label: status, className: 'bg-slate-100 text-slate-600' };
  
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border',
        config.className,
        className
      )}
      data-testid={`status-badge-${status}`}
    >
      {config.label}
    </span>
  );
};

const riskConfig = {
  low: { label: 'Faible', className: 'bg-emerald-50 text-emerald-700 border-emerald-100' },
  medium: { label: 'Moyen', className: 'bg-amber-50 text-amber-700 border-amber-100' },
  high: { label: 'Élevé', className: 'bg-rose-50 text-rose-700 border-rose-100' },
};

export const RiskBadge = ({ level, className }) => {
  const config = riskConfig[level] || riskConfig.low;
  
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border',
        config.className,
        className
      )}
      data-testid={`risk-badge-${level}`}
    >
      {config.label}
    </span>
  );
};

const channelConfig = {
  airbnb: { label: 'Airbnb', className: 'bg-rose-50 text-rose-600 border-rose-100' },
  booking: { label: 'Booking.com', className: 'bg-blue-50 text-blue-600 border-blue-100' },
  direct: { label: 'Direct', className: 'bg-slate-50 text-slate-600 border-slate-100' },
  other: { label: 'Autre', className: 'bg-slate-50 text-slate-500 border-slate-100' },
};

export const ChannelBadge = ({ channel, className }) => {
  const config = channelConfig[channel] || channelConfig.other;
  
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border',
        config.className,
        className
      )}
      data-testid={`channel-badge-${channel}`}
    >
      {config.label}
    </span>
  );
};

const jobTypeConfig = {
  guest_review: { label: 'Avis voyageur', className: 'bg-violet-50 text-violet-700 border-violet-100' },
  host_reply: { label: 'Réponse hôte', className: 'bg-cyan-50 text-cyan-700 border-cyan-100' },
};

export const JobTypeBadge = ({ type, className }) => {
  const config = jobTypeConfig[type] || { label: type, className: 'bg-slate-100 text-slate-600' };
  
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border',
        config.className,
        className
      )}
    >
      {config.label}
    </span>
  );
};

export default StatusBadge;
